const ACCESS_LEVELS = ['W', 'R', 'N'] as const; // Write, Read, None
export type PermissionAccessLevel = typeof ACCESS_LEVELS[number];
export const isAccessLevel = (x: any): x is PermissionAccessLevel => ACCESS_LEVELS.includes(x);

const PERMISSION_NAME_LIST = [
  'ModelStructureBalanceSheet',
  'ModelStructureScenarios',
  'ModelStructureLookupTables',
  'ModelStructureLiquiditySources',
  'ModelStructureExogenousLines',
  'ModelDataLookuptables',
  'ModelDataLiquiditySourcesEquations',
  'ModelDataExogenousLinesEquations',
  'ModelDataAuxiliaryAccountsEquations',
  'RunSimulation',
  'ManageResultsets',
  'Import',
  'GlobalSettings',
  'SystemSettings',
] as const;
export type Permission = typeof PERMISSION_NAME_LIST[number];
export const isPermission = (x: any): x is Permission => PERMISSION_NAME_LIST.includes(x);

export type PermissionList = { [section in Permission]: PermissionAccessLevel };
